import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
class TipoGrafico extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/TipoGraficoLookup" {...this.props} />;
  }
}

export default TipoGrafico;
